export const isTextSlug = (value) => {
  const slug = String(value ?? '').trim();
  return slug !== '' && !isNumericPathParam(slug);
};

export const getProductSlug = (product) => {
  if (product == null || product === '') return '';
  if (typeof product === 'string' || typeof product === 'number') return String(product);
  if (isTextSlug(product.slug)) return String(product.slug).trim();
  return String(product.id ?? '');
};

export const getCategorySlug = (category) => {
  if (category == null || category === '') return '';
  if (typeof category === 'string' || typeof category === 'number') return String(category);
  if (isTextSlug(category.slug)) return String(category.slug).trim();
  return String(category.id ?? '');
};

export const getProductUrl = (product) => `/products/${getProductSlug(product)}`;

export const getCategoryUrl = (category) => `/categories/${getCategorySlug(category)}`;

export const isNumericPathParam = (value) => /^\d+$/.test(String(value ?? ''));

export const getPathSegment = (pathname, prefix) => {
  const path = String(pathname ?? '');
  const base = String(prefix ?? '').replace(/\/$/, '');
  const pattern = new RegExp(`^${base}/([^/?#]+)`);
  const match = path.match(pattern);
  if (!match?.[1]) {
    return '';
  }

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

export const getCategorySlugFromPath = (pathname) => getPathSegment(pathname, '/categories');

export const getProductSlugFromPath = (pathname) => getPathSegment(pathname, '/products');

export const resolveCategoryId = (categories, slugOrId) => {
  if (!slugOrId) return null;

  let value = String(slugOrId);
  try {
    value = decodeURIComponent(value);
  } catch {
    // keep original value
  }

  if (isNumericPathParam(value)) return Number(value);

  const normalized = value.toLowerCase();
  const match = categories.find((item) => {
    const slug = String(item.slug ?? '').trim();
    return slug === value || slug.toLowerCase() === normalized;
  });

  return match?.id ?? null;
};

export const findCategoryBySlugOrId = (categories, slugOrId) => {
  const categoryId = resolveCategoryId(categories, slugOrId);
  if (!categoryId) {
    return null;
  }

  return categories.find((item) => Number(item.id) === Number(categoryId)) ?? null;
};

export const buildPaginatedPath = (basePath, page) => {
  if (!page || page <= 1) return basePath;
  const separator = basePath.includes('?') ? '&' : '?';
  return `${basePath}${separator}page=${page}`;
};
